import type { ChangelogEntry } from "./changelog.types";

export const CHANGELOG_ENTRIES: ChangelogEntry[] = [
  {
    version: "1.1.0",
    date: "2026-08-06",
    groups: [
      {
        kind: "added",
        items: [
          "Paginacija na stranici saveza za vijesti, članove, dokumente i reference.",
          "URL parametri na Pretrazi (pretraga, sortiranje, stranica) za dijeljenje i obnavljanje stanja.",
        ],
      },
      {
        kind: "improved",
        items: [
          "Gumb 'Natrag na pretragu' i povratak preglednikom sada vraćaju filtre i stranicu na Pretrazi.",
          "Stabilno sortiranje saveza na Pretrazi (pokrivenost, naziv, sport) bez ponavljanja zapisa između stranica.",
          "Dohvat podataka za 4 postojeća saveza s malom pokrivenosti.",
        ],
      },
    ],
  },
  {
    version: "1.0.0",
    date: "2026-08-05",
    groups: [
      {
        kind: "added",
        items: [
          "Stranica Greške za pregled zabilježenih grešaka prikupljanja podataka po savezima.",
          "Stranica Status s 14-dnevnim praćenjem dostupnosti Savezi API-ja i web stranica saveza.",
          "Stranica Promjene s bilješkama o izdanjima i novostima sustava.",
          "Automatsko bilježenje grešaka u workeru tijekom prikupljanja podataka.",
          "Periodične provjere dostupnosti API-ja (svakih 30 s) i saveznih URL-ova (svakih 5 min).",
        ],
      },
      {
        kind: "improved",
        items: [
          "Proširena navigacija s poveznicama na nadzorne stranice.",
          "Javni API endpointi za sažetak grešaka i agregiranu dostupnost.",
        ],
      },
    ],
  },
];
